<template>
  <div id="app" @click="h5headerHideFn">
    <headers ref="head"></headers>
    <router-view class="app-content" :class="current == 'home' ? 'no-bg' : ''" />
    <footers></footers>
  </div>
</template>

<script>
import headers from "./components/header.vue";
import footers from "./components/footer.vue";
export default {
  name: "App",
  components: {
    headers,
    footers,
  },
  data() {
    return {
      current: 'home'
    }
  },
  watch: {
    $route(to, from) {
      console.log(to, from, 'to, from');
      if (to.path == "/") {
        this.current = "home";
      } else {
        this.current = 'other'
      }
      console.log(this.current, '-----');
    },
  },
  methods: {
    h5headerHideFn() {
      console.log(this.$refs.head.current);
      this.$refs.head.current = '';
      this.$refs.head.childrenShow = '';
      // this.$children.h5show = false;
    },
  },
};
</script>

<style lang="less">
.index-img {
  width: 100%;
  height: auto;
}

.index-con {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;
}

.router {
  display: flex;
  margin: 23px 0 31px;
  align-items: center;

  span {
    color: rgba(31, 31, 31, 0.5);
    font-family: Canaro, Arial, sans-serif;
    font-size: 11px;
    line-height: 1.8;
    font-weight: 400;
    white-space: nowrap;
    cursor: pointer;
  }

  b {
    color: #f9b033;
    font-weight: 400;
    margin: 0 10px;
  }

  span:nth-last-of-type(1) {
    color: #333;
  }
}

.index {
  .el-carousel__indicator--horizontal {
    width: 20px;
    height: 20px;
    padding: 0;
    border-radius: 50%;
    background: #5b965a40;
    position: relative;
    margin: 0 10px 20px;
  }

  .el-carousel__button {
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    background: #d4ebfa;
    border-radius: 50%;
  }

  .el-carousel__indicator--horizontal.is-active {
    .el-carousel__button {
      background: #5b965a;
    }

    background: #5b965a;
  }

  .index-swiper {
    .el-carousel__container {
      height: 270px;
    }
  }

  .two-swiper {
    .el-carousel__container {
      height: 350px !important;
    }

    .el-carousel__arrow {
      background: #5b965a44;
      color: #333;
      transform: scale(1.2) translateY(-50%);

      i {
        font-size: 25px;
      }
    }
  }
}

.cup {
  cursor: pointer;
}

* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  font-size: 16px;
}

.app-content {
  margin-top: 155px;
  box-sizing: border-box;
  padding-top: 20px;
  // border-top: 1px solid #666;
  //background-image: url('../src/assets/images/divider.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top center;
}

.no-bg {
  background-image: none;
}

// .app-content::before {
//   content: '';
//   left: 0;
//   width: 100%;
//   top: 0;
//   background-color: #666;
//   height: 1px;
//   position: absolute;
// }


#app,
html,
body {
  width: 100%;
  height: 100%;
}

.u-line-1 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.u-line-2 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.u-line-3 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.u-line-6 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  overflow: hidden;
}

@media screen and (max-width: 768px) {

  .people-lists-contents.el-carousel--horizontal,
  .people-lists-contents .el-carousel__container {
    height: 730px;
  }

  .index-swiper .el-carousel__container {
    height: 120px;
  }
}


@media screen and (max-width: 768px) {
  .index {

    .el-carousel__button {
      display: none;
    }

    .el-carousel__indicator--horizontal {
      display: none;
    }
  }

  .index .index-con {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue